import {
  Globe2,
  Send,
  Download,
  ShoppingCart,
  Landmark,
  Bitcoin,
  Building2,
  Workflow,
  Wallet,
  CreditCard,
  Code2,
  LayoutDashboard,
  Smartphone,
  ShieldCheck,
  Zap,
  BarChart3,
  Newspaper,
  BookOpen,
  Quote,
  FileText,
  LifeBuoy,
  Activity,
  Terminal,
  Users,
  RefreshCw,
  Link as LinkIcon,
  Sparkles,
  Lock,
  Fingerprint,
  Eye,
  type LucideIcon,
} from 'lucide-react'

const icons: Record<string, LucideIcon> = {
  Globe2,
  Send,
  Download,
  ShoppingCart,
  Landmark,
  Bitcoin,
  Building2,
  Workflow,
  Wallet,
  CreditCard,
  Code2,
  LayoutDashboard,
  Smartphone,
  ShieldCheck,
  Zap,
  BarChart3,
  Newspaper,
  BookOpen,
  Quote,
  FileText,
  LifeBuoy,
  Activity,
  Terminal,
  Users,
  RefreshCw,
  LinkIcon,
  Sparkles,
  Lock,
  Fingerprint,
  Eye,
}

export function Icon({ name, className }: { name: string; className?: string }) {
  const Cmp = icons[name] ?? Sparkles
  return <Cmp className={className} aria-hidden="true" />
}
